import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_5: R2BReferralBrandEntity = {
  token: "r2b_referral_5",
  type: "r2bReferralBrand",
  name: "Serene Scents",
  email: "jane.smith@example.com",
  website: "homehaven.net",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
